export * from './about/about.component';
export * from './contact';
export * from './home/home.component';
export * from './notfound/notfound.component';
export * from './solutions';
